import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeLayers,
  FontAwesomeLayersText,
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

import {
  faCaretDown as freeFasFaCaretDown,
  faCaretRight as freeFasFaCaretRight,
  faCaretUp as freeFasFaCaretUp,
  faLongArrowAltLeft as freeFasFaLongArrowAltLeft,
  faLongArrowAltDown as freeFasFaLongArrowAltDown,
  faEnvelope as freeFasFaEnvelope,
  faCircleUser as freeFasFaCircleUser,
  faBars as freeFasFaBars,
  faTimes as freeFasFaTimes,
  faChevronRight as freeFasFaChevronRight,
  faChevronLeft as freeFasFaChevronLeft,
  faChevronDown as freeFasFaChevronDown,
  faChevronUp as freeFasFaChevronUp,
  faCircleExclamation as freeFasFaCircleExclamation,
  faRotateRight as freeFasFaRotateRight,
  faRotateLeft as freeFasFaRotateLeft,
  faArrowsUpDownLeftRight as freeFasFaArrowsUpDownLeftRight,
  faSquarePhone as freeFasFaSquarePhone
} from '@fortawesome/free-solid-svg-icons'

import {
  faFacebook as freeFabFaFacebook,
  faTwitter as freeFabFaTwitter,
  faLinkedin as freeFabFaLinkedin
} from '@fortawesome/free-brands-svg-icons'

library.add(
  freeFasFaCaretDown,
  freeFasFaCaretRight,
  freeFasFaCaretUp,
  freeFasFaLongArrowAltLeft,
  freeFasFaLongArrowAltDown,
  freeFasFaEnvelope,
  freeFasFaCircleUser,
  freeFasFaBars,
  freeFasFaTimes,
  freeFasFaChevronRight,
  freeFasFaChevronLeft,
  freeFasFaChevronDown,
  freeFasFaChevronUp,
  freeFasFaCircleExclamation,
  freeFasFaRotateRight,
  freeFasFaRotateLeft,
  freeFasFaArrowsUpDownLeftRight,
  freeFasFaSquarePhone,
  freeFabFaFacebook,
  freeFabFaTwitter,
  freeFabFaLinkedin
)

config.autoAddCss = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
Vue.component('FontAwesomeLayersText', FontAwesomeLayersText)
